export enum IDPHint {
  GSUITE = 'gsuite',
  ENTRAID = 'wtwentraid',
  CHOICE = 'choice',
}

export const LOGIN_HELP_EMAIL_ADDRESS = 'login-help@newfront.com';
